import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02d42a24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "result-card-component" }
const _hoisted_2 = { class: "info-name" }
const _hoisted_3 = { class: "info-line" }
const _hoisted_4 = {
  key: 0,
  class: "info-label"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data de nascimento:", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "info-value" }
const _hoisted_8 = {
  key: 0,
  class: "info-line"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "CPF:")
], -1))
const _hoisted_10 = { class: "info-value" }
const _hoisted_11 = {
  key: 1,
  class: "info-line"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Localidade:")
], -1))
const _hoisted_13 = { class: "info-value" }
const _hoisted_14 = { class: "result-test-header" }
const _hoisted_15 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_16 = { class: "title open-sans-font" }
const _hoisted_17 = { class: "result-test-image d-flex justify-content-center" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "info-value-test" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Tipo de Teste:", -1))
const _hoisted_21 = { class: "info-value test-name-result" }
const _hoisted_22 = { class: "info-value-test" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Data de Registro:", -1))
const _hoisted_24 = { class: "info-value test-date" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.patient.name), 1),
    _createElementVNode("div", _hoisted_3, [
      (this.testType != 'hiv')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.patient.birthdate), 1)
    ]),
    (!_ctx.patient.isForeigner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.cpfMask()), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.patient.isForeigner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.patient.city) + " - " + _toDisplayString(_ctx.patient.state), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.testType == 'hiv'
              ? `Resultado ${_ctx.resultInfosHiv.title}`
              : _ctx.resultInfos.title) + " " + _toDisplayString(_ctx.testType == 'hiv' ? '' : _ctx.resultInfos.subtitle), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("img", {
        src: _ctx.testType == 'hiv' ? _ctx.resultInfosHiv.imageResult : _ctx.testImage
      }, null, 8, _hoisted_18)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.testName), 1)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.getCurrentDate()), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(
        _ctx.testType == 'hiv' ? 'result-card-footer-hiv' : 'result-card-footer'
      )
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.agePatient()), 1)
    ], 2),
    _hoisted_25
  ]))
}